import { startCase } from 'lodash-es';

import { TransformationType, IndicatorType } from 'shared/types/transformation';
import { ValueOf } from 'shared/types/common';

export const getReadableTransformationType = (transformationType: TransformationType | string) => (
  startCase(transformationType.toLowerCase())
);

export const getReadableIndicatorType = (indicatorType: IndicatorType | string) => (
  indicatorType.replace(/_+/, ' ')
);
